import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SignIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M12 21C16.92 21 21 16.91 21 12C21 7.08 16.91 3 11.99 3C7.08 3 3 7.08 3 12C3 16.91 7.09 21 12 21ZM12 19.5C7.84 19.5 4.51 16.16 4.51 12C4.51 7.84 7.83 4.5 11.99 4.5C16.16 4.5 19.49 7.84 19.5 12C19.51 16.16 16.16 19.5 12 19.5ZM15.49 9.53L16.12 8.89C16.4 8.59 16.43 8.27 16.16 8L15.96 7.8C15.7 7.54 15.37 7.56 15.09 7.84L14.44 8.48L15.49 9.53ZM9.17 15.82L14.96 10.05L13.91 9.01L8.14 14.77L7.63 15.94C7.54 16.16 7.76 16.35 7.95 16.28L9.17 15.82Z"
				fill="white"
			/>
		</svg>
	)
}

export default SignIcon
